import MetricBase from "models/metrics/MetricBase";
import CurrencyUnit from "models/metrics/unit/CurrencyUnit";
import i18n from "i18next";
import PerformanceGroup from "../../../../groups/PerformanceGroup";

class MetricRevenuePerclick extends MetricBase {
    constructor() {
        super({
            field: "metric_revenue_per_click",
            defaultVisibility: true,
            unit: new CurrencyUnit(),
            chartName: i18n.t("metrics.google_hotel_ads.revenuePerclick.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads.revenuePerclick.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads.revenuePerclick.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricRevenuePerclick;
